export default {
  navHome: "首頁",
  navProducts: "產品中心",
  navCases: "應用案例",
  navAbout: "關於詠遠",
  deliverTo: "交貨至:",
  langCurrencyLabel: "繁體中文",
  localeLangTitle: "設置語言",
  localeLangDesc: "請選擇您的首選語言。語言與網址將同步切換。",
  language: "語言",
  save: "保存",
  uiClose: "關閉",
  carouselPrev: "上一個產品",
  carouselNext: "下一個產品",
  heroSlidePrev: "上一張",
  heroSlideNext: "下一張",
  heroSlideDot: "切換到第{n}張",
  coreProducts: "助力現實世界創作",
  coreProductsDesc: "從創意到生意，YONGYUAN提供UV打印機、水晶標打印機、圓柱體高速打印機和DTF打印機、DTG打印機，將創意轉化為產品、品牌和機遇。",
  scenariosTitle: "賦能每一個場景",
  scenariosDesc: "無論您是打造品牌、副業創收還是興趣創作，YONGYUAN 總有一款解決方案能滿足您的需求。",
  scenarioStudio: "工作室",
  scenarioStudioDesc: "高客單定製、小批量打樣、打造品牌",
  scenarioRetail: "品牌門店",
  scenarioRetailDesc: "提升客戶停留時長、增加門店營收",
  scenarioMarket: "集市擺攤",
  scenarioMarketDesc: "現場定製、銷售成品、副業創收",
  scenarioEnterprise: "企業定製",
  scenarioEnterpriseDesc: "批量定製、品牌周邊、商務禮品",
  scenarioEcommerce: "直播帶貨",
  scenarioEcommerceDesc: "爆款打樣、柔性供貨、快速上新",
  scenarioStore: "電商店鋪",
  scenarioStoreDesc: "店鋪定製、爆款周邊、差異化經營",
  scenarioFactory: "工廠產線",
  scenarioFactoryDesc: "批量生產、穩定輸出、降本增效",
  scenarioAdvertising: "廣告製作",
  scenarioAdvertisingDesc: "標識標牌、展示物料、活動物料",
  industries: "行業應用",
  industriesDesc: "為不同行業的彩色印刷需求提供數字噴墨打印解決方案。",
  applicationsTitle: "解鎖多元材質與色彩應用，滿足日常與商業需求。",
  applicationsDesc: "YONGYUAN UV打印設備可適配多種材質與工藝場景，助力個性化定製與規模化生產。",
  casesHeroDesc: "覆蓋1000+產品應用場景",
  casesBreadcrumbHome: "首頁",
  casesBreadcrumbCenter: "應用場景",
  casesEmpty: "暫無該分類應用案例",
  customerStoriesTitle: "全球客戶正在使用詠遠品牌打印機創造價值",
  customerStoriesSubtitle: "來自172個國家客戶的真實安裝、培訓與應用現場",
  customerStoriesTrustedTitle: "Trusted Worldwide",
  customerStoriesStat1Value: "53000+",
  customerStoriesStat1Label: "設備交付",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "服務國家",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "行業經驗",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "技術支持",
  customerStoriesBadge: "已展示 {count} 張國外客戶合照",
  customerStoriesPlaceholder: "放置客戶合照",
  customerStoriesPhotoAlt: "YONGYUAN客戶與打印機合影",
  customerStoryCountryUsaNewYork: "美國紐約",
  customerStoryCountryGermany: "德國",
  customerStoryCountryThailand: "泰國",
  customerStoryCountrySpain: "西班牙",
  customerStoryCountryBrazil: "巴西",
  customerStoryCountryAustralia: "澳洲",
  customerStoryCountrySaudiArabia: "沙特",
  customerStoryCountrySingapore: "新加坡",
  customerStoryCountryKorea: "韓國",
  customerStoryCountryIsrael: "以色列",
  customerStoryCountryKazakhstan: "哈薩克斯坦",
  customerStoryCountryMexico: "墨西哥",
  customerStoryCountryArgentina: "阿根廷",
  customerStoryCountryPhilippines: "菲律賓",
  customerStoryCountryIndonesia: "印尼",
  customerStoryCountryNetherlands: "荷蘭",
  customerStoryCountrySweden: "瑞典",
  customerStoryCountrySouthAfrica: "南非",
  customerStoryCountryMalaysia: "馬來西亞",
  customerStoryCountryTaiwan: "臺灣",
  customerStoryCountryUsa: "美國",
  customerStoryCountryCambodia: "柬埔寨",
  customerStoryCountryCanada: "加拿大",
  customerStoryCaption01: "美國｜6090 UV Printer",
  customerStoryCaption02: "德國｜F33 DTF Printer",
  customerStoryCaption03: "泰國｜3250 UV Printer",
  customerStoryCaption04: "西班牙｜3250 UV Printer",
  customerStoryCaption05: "巴西｜2030 UV Printer",
  customerStoryCaption06: "澳洲｜F33 DTF Printer",
  customerStoryCaption07: "沙特｜2030 UV Printer",
  customerStoryCaption08: "新加坡｜F33 DTF Printer",
  customerStoryCaption09: "韓國｜F33 DTF Printer",
  customerStoryCaption10: "以色列｜UVC33 DTF Printer",
  customerStoryCaption11: "哈薩克斯坦｜4030 UV Printer",
  customerStoryCaption12: "墨西哥｜4060 UV Printer",
  customerStoryCaption13: "阿根廷｜4060 UV Printer",
  customerStoryCaption14: "菲律賓｜6090 UV Printer",
  customerStoryCaption15: "印尼｜4030 UV Printer",
  customerStoryCaption16: "荷蘭｜4030 UV Printer",
  customerStoryCaption17: "瑞典｜4060 UV Printer",
  customerStoryCaption18: "德國｜2030 UV Printer",
  customerStoryCaption19: "南非｜2030 UV Printer",
  customerStoryCaption20: "馬來西亞｜F33 DTF Printer",
  customerStoryCaption21: "中國臺灣｜UVC33 DTF Printer",
  customerStoryCaption22: "美國｜F70Pro DTF Printer",
  customerStoryCaption23: "美國｜2513 UV Printer",
  customerStoryCaption24: "美國｜6090 UV Printer",
  customerStoryCaption25: "美國｜2030 UV Printer",
  customerStoryCaption26: "美國｜3250 UV Printer",
  customerStoryCaption27: "韓國｜4060 UV Printer",
  customerStoryCaption28: "荷蘭｜4060 UV Printer",
  customerStoryCaption29: "柬埔寨｜4030 UV Printer",
  customerStoryCaption30: "加拿大｜F33 DTF Printer",
  servicePartnerTitle: "認識一下 YONGYUAN 服務團隊，您的創意合作伙伴",
  servicePartnerDesc: "覆蓋全球的服務網絡與專業支持體系，為您的設備使用與業務增長保駕護航。",
  serviceSupportTitle: "標準支持",
  serviceSupportDesc: "提供安裝指導、基礎培訓與日常使用答疑，保障設備穩定運行。",
  servicePresaleTitle: "售前演示與諮詢",
  servicePresaleDesc: "根據您的應用場景與產能需求，提供方案演示與選型建議。",
  serviceLifetimeTitle: "終身技術支持",
  serviceLifetimeDesc: "持續的技術響應與工藝支持，陪伴您的業務長期發展。",
  serviceCareTitle: "升級至 YONGYUAN Care",
  serviceCareDamageTitle: "意外損壞保障",
  serviceCareDamageDesc: "為設備提供更全面的保障方案，降低突發風險帶來的損失。",
  serviceCareExchangeTitle: "快速置換服務",
  serviceCareExchangeDesc: "在符合條件的情況下，優先安排快速置換，快速回籠資金。",
  viewProduct: "查看產品",
  learnMore: "瞭解更多",
  catUv: "UV打印機",
  catUvNav: "UV打印機",
  catCylinder: "圓柱體打印機",
  catCylinderNav: "圓柱體打印機",
  catCrystal: "水晶標打印機",
  catCrystalNav: "水晶標打印機",
  catDtf: "DTF打印機",
  catDtfNav: "DTF打印機",
  catDtg: "DTG打印機",
  catDtgNav: "DTG打印機",
  companyName: "深圳詠遠科技有限公司",
  phone: "聯繫電話：17748697567 唐經理",
  email: "聯繫郵箱：sales@yongyuanprinter.com",
  copyright: "Copyright © 2012-2026 深圳詠遠科技有限公司 版權所有",
  productsHeroTitle: "產品中心",
  productsHeroDesc: "覆蓋UV平板、圓柱打印、UV DTF、水晶標、DTF及DTG全系列設備，滿足個性化定製、批量生產與工業應用需求。",
  productsBreadcrumbHome: "首頁",
  productsBreadcrumbCenter: "產品中心",
  productsEmpty: "該分類產品即將上線，敬請期待。",
  productsQuoteTitle: "獲取方案與報價",
  productsQuoteDesc: "告訴我們您的應用場景與產能需求，我們將為您匹配合適的設備方案。",
  productsContact: "聯繫諮詢",
  aboutHeroTitle: "關於詠遠",
  aboutHeroDesc: "23年專注UV打印設備研發生產",
  productA23Subtitle: "小型桌面UV打印解決方案",
  productA23Industry: "適用場景：手機殼個性化定製｜鑰匙扣徽章｜U盤名片小禮品｜打樣與工作室創業｜等等",
  productA23Feature1: "20×30cm幅面",
  productA23Feature2: "6色精準打印",
  productA23Feature3: "紅外自動測高",
  productA35Subtitle: "桌面級UV平板打印解決方案",
  productA35Industry: "適用場景：獎牌獎盃｜皮革卡包｜化妝品小盒｜亞克力擺件與紀念品｜等等",
  productA35Feature1: "32×50cm幅面",
  productA35Feature2: "6色智能墨路",
  productA35Feature3: "紅外自動測高",
  productA43Subtitle: "商用A3幅面UV打印解決方案",
  productA43Industry: "適用場景：木板銘牌｜亞克力導視｜UV DTF轉印膜｜小型包裝與禮品打樣｜等等",
  productA43Feature1: "40×30cm打印幅面",
  productA43Feature2: "8色可選方案",
  productA43Feature3: "多材質適配",
  productA46Subtitle: "商用A2幅面UV打印解決方案",
  productA46Industry: "適用場景：燈光畫｜禮盒彩印｜玻璃工藝品｜文創周邊小批量量產｜等等",
  productA46Feature1: "40×60cm打印幅面",
  productA46Feature2: "8色可選方案",
  productA46Feature3: "穩定量產輸出",
  productA57Subtitle: "A2+幅面UV平板打印解決方案",
  productA57Industry: "適用場景：行李箱面板｜裝飾畫｜瓷磚畫｜中型工藝品定製｜等等",
  productA57Feature1: "50×70cm幅面",
  productA57Feature2: "8色可選方案",
  productA57Feature3: "高精度細節還原",
  productA69Subtitle: "商用A1大幅面UV打印解決方案",
  productA69Industry: "適用場景：傢俱面板｜玻璃移門｜塑料/金屬板材｜廣告展板小批量｜等等",
  productA69Feature1: "60×90cm打印幅面",
  productA69Feature2: "8-15色可選方案",
  productA69Feature3: "工業級穩定輸出",
  productA1216Subtitle: "超大幅面工業級UV打印解決方案",
  productA1216Industry: "適用場景：KT板展架｜門頭招牌｜燈箱片｜商場導視與背景牆｜等等",
  productA1216Feature1: "120×160cm幅面",
  productA1216Feature2: "視覺定位系統",
  productA1216Feature3: "多噴頭量產方案",
  productA2513Subtitle: "旗艦級工業UV平板打印解決方案",
  productA2513Industry: "適用場景：木門櫥櫃｜家居裝飾板｜背景牆整板｜廣告與家裝批量生產｜等等",
  productA2513Feature1: "250×130cm幅面",
  productA2513Feature2: "視覺定位系統",
  productA2513Feature3: "連續批量生產",
  productA3220Subtitle: "超寬幅工業UV平板打印解決方案",
  productA3220Industry: "適用場景：巖板整板｜大型玻璃幕牆｜建築裝飾板｜高端整牆定製｜等等",
  productA3220Feature1: "320×200cm打印幅面",
  productA3220Feature2: "視覺定位系統",
  productA3220Feature3: "連續批量生產",
  productCylinderElfSubtitle: "高速圓柱體打印解決方案",
  productCylinderElfIndustry: "適用場景：保溫杯環印｜酒瓶定製｜化妝品瓶｜杯壺禮品小批量｜等等",
  productCylinderElfFeature1: "360°環繞打印",
  productCylinderElfFeature2: "杯壺定製",
  productCylinderElfFeature3: "快速換治具",
  productCupPlusSubtitle: "多規格圓柱打印解決方案",
  productCupPlusIndustry: "適用場景：保溫杯批量｜酒瓶/香水瓶｜企業禮品｜360°無縫環繞印刷｜等等",
  productCupPlusFeature1: "多規格治具",
  productCupPlusFeature2: "產線高效",
  productCupPlusFeature3: "穩定輸出",
  productCrystal60Subtitle: "商業級水晶標打印解決方案",
  productCrystal60Industry: "適用場景：服裝輔料標｜包裝盒立體標｜玻璃金屬轉印標｜促銷禮品標識｜等等",
  productCrystal60Feature1: "60cm幅寬",
  productCrystal60Feature2: "打印燙金一體",
  productCrystal60Feature3: "高效收料",
  productCrystal60UltraSubtitle: "旗艦級水晶標打印解決方案",
  productCrystal60UltraIndustry: "適用場景：品牌包裝立體標｜燙金燙銀標｜禮品深加工｜大批量連續轉印｜等等",
  productCrystalC60UltraFeature1: "60cm幅寬",
  productCrystalC60UltraFeature2: "燙金燙銀3D標",
  productCrystalC60UltraFeature3: "批量連續生產",
  productCrystal30Subtitle: "小型水晶標打印解決方案",
  productCrystal30Industry: "適用場景：手機殼轉印標｜文創小標｜樣標打樣｜小批量多款定製｜等等",
  productCrystal30Feature1: "30cm幅寬",
  productCrystal30Feature2: "高精度標貼",
  productCrystal30Feature3: "操作便捷",
  productDtfF20Subtitle: "桌面型白墨燙畫打印解決方案",
  productDtfF20Industry: "適用場景：個性T恤｜工作室創業｜小單快反｜帽衫衛衣燙畫｜等等",
  productDtfF20Feature1: "A4打印尺寸",
  productDtfF20Feature2: "白墨彩圖一體",
  productDtfF20Feature3: "智能墨路系統",
  productDtfF30Subtitle: "商用白墨燙畫打印解決方案",
  productDtfF30Industry: "適用場景：服裝定製店｜電商快反｜團隊服｜文化衫短單｜等等",
  productDtfF30Feature1: "A3打印尺寸",
  productDtfF30Feature2: "單頭手/自動可選",
  productDtfF30Feature3: "智能墨路系統",
  productDtfF30ProSubtitle: "高效白墨燙畫打印解決方案",
  productDtfF30ProIndustry: "適用場景：服裝加工廠｜批量熱轉印｜品牌代工｜門店連單生產｜等等",
  productDtfF30ProFeature1: "A3雙噴頭",
  productDtfF30ProFeature2: "自動收膜",
  productDtfF30ProFeature3: "智能墨路系統",
  productDtfF33Subtitle: "靈活配置白墨燙畫解決方案",
  productDtfF33Industry: "適用場景：定製門店｜文創周邊｜中小批量燙畫｜多品類服裝訂單｜等等",
  productDtfF33Feature1: "A3打印尺寸",
  productDtfF33Feature2: "靈活工位配置",
  productDtfF33Feature3: "智能墨路系統",
  productDtfF70ProSubtitle: "工業級寬幅白墨燙畫解決方案",
  productDtfF70ProIndustry: "適用場景：服裝工廠產線｜大幅燙畫｜批量訂單｜連續收放料生產｜等等",
  productDtfF70ProFeature1: "70cm打印寬幅",
  productDtfF70ProFeature2: "2-4噴頭可選",
  productDtfF70ProFeature3: "自動進出料續打",
  productDtf30Subtitle: "緊湊型白墨燙畫設備",
  productDtf30Feature1: "小批量定製",
  productDtf30Feature2: "色彩還原好",
  productDtf30Feature3: "易於上手",
  productDtgPrintSubtitle: "數碼直噴打印機",
  productDtgPrintFeature1: "多材質直噴",
  productDtgPrintFeature2: "高頻生產",
  productDtgPrintFeature3: "穩定耐用",
  productDtg3250DSubtitle: "DTF&DTG二合一打印解決方案",
  productDtg3250DIndustry: "適用場景：服裝綜合門店｜DTF燙畫+DTG直噴｜柔性接單｜一件起訂｜等等",
  productDtg3250DFeature1: "A3+打印幅面",
  productDtg3250DFeature2: "DTF/DTG雙模式",
  productDtg3250DFeature3: "智能墨路系統",
  productDtg3646TSubtitle: "雙工位DTG直噴打印解決方案",
  productDtg3646TIndustry: "適用場景：T恤衛衣直噴｜批量文化衫｜直播電商供貨｜雙工位連續產出｜等等",
  productDtg3646TFeature1: "雙工位連續生產",
  productDtg3646TFeature2: "效率提升100%",
  productDtg3646TFeature3: "智能墨路系統",
  productDtgMaxSubtitle: "工業級數碼直噴機型",
  productDtgMaxFeature1: "工業級產能",
  productDtgMaxFeature2: "穩定耐用",
  productDtgMaxFeature3: "連續作業",
  app01Title: "手機殼",
  app02Title: "高爾夫球",
  app03Title: "石板畫",
  app04Title: "圓珠筆",
  app05Title: "眼鏡盒",
  app06Title: "木版畫",
  app07Title: "易拉罐",
  app08Title: "鍵盤",
  app09Title: "保溫杯",
  app10Title: "行李箱",
  app11Title: "亞克力",
  app12Title: "筆記本",
  app13Title: "徽章",
  app14Title: "皮質卡包",
  app15Title: "軍牌",
  app16Title: "玻璃畫",
  appDtgCase01: "T恤文化衫",
  appDtgCase02: "連帽衛衣",
  globeTapHint: "點選國家，查看服務覆蓋",
  regionCn: "中國",
  regionUs: "美國",
  regionGb: "英國",
  regionDe: "德國",
  regionAe: "阿聯酋",
  regionIn: "印度",
  regionJp: "日本",
  regionVn: "越南",
  regionBr: "巴西",
  regionAu: "澳大利亞",
  cityShanghai: "上海",
  cityShenzhen: "深圳",
  cityDetroit: "底特律",
  cityManchester: "曼徹斯特",
  cityStuttgart: "斯圖加特",
  cityDubai: "迪拜",
  cityPune: "浦那",
  cityOsaka: "大阪",
  cityHoChiMinh: "胡志明市",
  citySaoPaulo: "聖保羅",
  cityMelbourne: "墨爾本",
  brandStatsTitle: "Trusted Worldwide",
  brandStat1Value: "53000+",
  brandStat1Label: "設備交付",
  brandStat2Value: "172+",
  brandStat2Label: "服務國家",
  brandStat3Value: "23+",
  brandStat3Label: "行業經驗",
  brandStat4Value: "24/7",
  brandStat4Label: "技術支持"
};
